import { Component, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Paginator } from 'primeng/paginator';
import { Subject, debounceTime, distinctUntilChanged, filter, map } from 'rxjs';
import { CommonService } from 'src-adisco/services/common.service';
import { UserService } from 'src/app/admin/core/services/user.service';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';

interface PageEvent {
    first: number;
    rows: number;
    page: number;
    pageCount: number;
}

@Component({
    selector: 'app-suppliers',
    templateUrl: 'suppliers.component.html',
    styleUrls: ['./suppliers.component.css'],
})
export class SuppliersComponent {
    @ViewChild('paginator1', { static: false }) paginator1: Paginator;
    @ViewChild('paginator2', { static: false }) paginator2: Paginator;
    @ViewChild('containerSuppliers') containerSuppliers: ElementRef | undefined;
    formPagination!: FormGroup;
    listRows: any[] = [21, 42, 84];
    listSuppliers: any[] = [];
    loadingStatus = false;
    first1: number = 0;
    searchSupplier = '';
    private searchSupplier$ = new Subject<string>();
    autocompleteSearchlistSuppliers: any[] = [];
    loading:boolean = false

    rows1: number = 10;

    first2: number = 0;

    rows2: number = 10;

    first3: number = 0;

    rows3: number = 12;

    totalRecords: number;

    rows: number = 1; // Số hàng mặc định mỗi trang
    currentPage = 1;
    totalPages = 0;
    isUpdating = false;
    rowsPerPageOptions: number[] = [1, 2, 3]; // Các tùy chọn số hàng mỗi trang
    userId = localStorage.getItem('userid');
    listMemberCatalogSegmentation: any[] = [];

    constructor(
        private _fb: FormBuilder,
        private dynamicDocumentService: DynamicDocumentService,
        private router: Router,
        public userService: UserService,
        private _commonService: CommonService
    ) {
        this.formPagination = this._fb.group({
            rows: [21],
            page: [1],
        });

        if (this.userId) {
            this._commonService
                .getUser(this.userId)
                .pipe(
                    filter((res) => !!res.email),
                    map((res) => {
                        const currentUser = res;
                        const linkToLegalEntityId =
                            currentUser?.linkToLegalEntity?.documentId ?? '';

                        return linkToLegalEntityId as string;
                    })
                )
                .subscribe((linkToLegalEntityId) => {
                    this._commonService.getInfoMember(linkToLegalEntityId).subscribe({
                        next: (res) => {
                            this.listMemberCatalogSegmentation =
                                res?.memberCatalogSegmentation?.map((seg: any) => seg?.value) ?? [];

                            this.setSearchPipe();
                            this.getListSuppliers();
                            // if (!this.router.url.includes("/catalogues/suppliers/")) { // Temporary comment Chibuzo code

                            this.setSearchPipe();
                            //   this.getSupplisersSimple();
                            // }
                        },
                        error: (error) => {},
                    });
                });
        }
    }

    ngOnInit(): void {}

    ngAfterViewInit() {
        this.updatePaginators(this.currentPage);
    }

    onPageChange(event: PageEvent) {
        if (this.isUpdating) {
            return;
        }
        this.isUpdating = true;
        this.currentPage = event.page;
        this.rows3 = this.formPagination.value.rows;
        this.formPagination.patchValue({
            page: event.page + 1,
        });
        this.paginator1?.changePage(this.currentPage);
        this.paginator2?.changePage(this.currentPage);
        this.getListSuppliers(); // call the simplified method
        //this.getSupplisersSimple()
        this.isUpdating = false;
        this.containerSuppliers?.nativeElement?.scrollIntoView({ behavior: 'smooth' });
    }

    updatePaginators(page: number) {
        this.paginator1?.changePage(page);
        this.paginator2?.changePage(page);
    }

    filterRows(): void {
        this.formPagination.patchValue({
            rows: this.formPagination.value.rows,
            // page: 1,
        });
        this.getListSuppliers();
        this.paginator1?.changePageToFirst(event);
        this.paginator2?.changePageToFirst(event);
    }

    // getListSuppliers(): void {
    //   let filters = [
    //     {
    //       fieldName: 'companyName',
    //       conditions: [{ type: 'CONTAINS', value: this.searchSupplier }],
    //     },
    //     {
    //       fieldName: 'typeOfLegalEntity',
    //       conditions: [
    //         {
    //           type: 'EQUALS',
    //           value: 'FOURNISSEUR',
    //         },
    //       ],
    //     },
    //     {
    //       fieldName: 'status',
    //       conditions: [
    //         {
    //           type: 'EQUALS',
    //           value: 'Publié',
    //         },
    //       ],
    //     },
    //   ];

    //   if (this.listMemberCatalogSegmentation.length) {
    //     filters.push({
    //       fieldName: "code",
    //       conditions: [
    //         {
    //           type: "IN",
    //           value: this.listMemberCatalogSegmentation as any
    //         }
    //       ]
    //     })
    //   };

    //   this.dynamicDocumentService
    //     .find({
    //       collectionName: 'dynamic_legal_entity',
    //       filters: filters,
    //       sorts: {
    //         "companyName": "ASC"
    //       },
    //       page: this.formPagination.value.page,
    //       pageSize: this.formPagination.value.rows,
    //     })
    //     .subscribe((res: any) => {
    //       this.listSuppliers = res.content;
    //       this.totalRecords = res.totalElements
    //       this.rows3 = res.size;
    //       this.totalPages = Math.ceil(this.totalRecords / this.rows3);
    //     });
    // }
    getSupplisersSimple() {
        this.dynamicDocumentService
            .findLegalEntity({
                collectionName: 'dynamic_legal_entity',
                sortField: 'companyName',
                sortOrder: 'ASC',
                typeOfLegalEntity: 'FOURNISSEUR',
                status: 'Publié',
                page: this.formPagination.value.page,
                pageSize: this.formPagination.value.rows,
            })
            .subscribe((res: any) => {
                this.listSuppliers = res.content;
                this.totalRecords = res.totalElements;
                this.rows3 = res.size;
                this.totalPages = Math.ceil(this.totalRecords / this.rows3);
            });
    }

    getListSuppliers(): void {
        let filters: any[] = [];

        // Add companyName filter if this.searchSupplier is not empty
        if (this.searchSupplier) {
            filters.push({
                fieldName: 'companyName',
                conditions: [{ type: 'CONTAINS', value: this.searchSupplier }],
            });
        }

        // Add typeOfLegalEntity filter (since the value is static, it's always included)
        filters.push({
            fieldName: 'typeOfLegalEntity',
            conditions: [
                {
                    type: 'EQUALS',
                    value: 'FOURNISSEUR',
                },
            ],
        });

        // Add status filter (since the value is static, it's always included)
        filters.push({
            fieldName: 'status',
            conditions: [
                {
                    type: 'EQUALS',
                    value: 'Publié',
                },
            ],
        });

        // Add code filter if listMemberCatalogSegmentation is not empty
        if (this.listMemberCatalogSegmentation && this.listMemberCatalogSegmentation.length) {
            const condition = this.listMemberCatalogSegmentation.map((el) => ({
                type: 'CONTAINS',
                value: el,
            }));
            filters.push({
                fieldName: 'code',
                conditions: condition
            });
        }
        
        this.loading = true

        // Call the service with dynamic filters
        this.dynamicDocumentService
            .find({
                collectionName: 'dynamic_legal_entity',
                filters: filters,
                sorts: {
                    companyName: 'ASC',
                },
                page: this.formPagination.value.page,
                pageSize: this.formPagination.value.rows,
            })
            .subscribe((res: any) => {
                this.listSuppliers = res.content;
                this.totalRecords = res.totalElements;
                this.rows3 = res.size;
                this.totalPages = Math.ceil(this.totalRecords / this.rows3);
                this.loading = false;
            });
    }

    onSearchInput(): void {
        this.searchSupplier$.next(this.searchSupplier);
    }

    setSearchPipe() {
        this.searchSupplier$
            .pipe(
                debounceTime(300), // 300ms delay
                distinctUntilChanged()
            )
            .subscribe((searchSupplier: string) => {
                if (searchSupplier && searchSupplier.length >= 2) {
                    let filters = [
                        {
                            fieldName: 'companyName',
                            conditions: [{ type: 'CONTAINS', value: searchSupplier }],
                        },
                        {
                            fieldName: 'typeOfLegalEntity',
                            conditions: [
                                {
                                    type: 'EQUALS',
                                    value: 'FOURNISSEUR',
                                },
                            ],
                        },
                        {
                            fieldName: 'status',
                            conditions: [
                                {
                                    type: 'EQUALS',
                                    value: 'Publié',
                                },
                            ],
                        },
                    ];

                    if (this.listMemberCatalogSegmentation.length) {
                        filters.push({
                            fieldName: 'code',
                            conditions: [
                                {
                                    type: 'IN',
                                    value: this.listMemberCatalogSegmentation as any,
                                },
                            ],
                        });
                    }

                    this.dynamicDocumentService
                        .find({
                            collectionName: 'dynamic_legal_entity',
                            filters: filters,
                            sorts: {
                                companyName: 'ASC',
                            },
                            page: 1,
                            pageSize: 5,
                        })
                        .subscribe((res: any) => {
                            this.autocompleteSearchlistSuppliers = res.content;
                        });
                }
            });
    }

    filterCompany(): void {
        this.formPagination.patchValue({
            page: 1,
        });
        this.getListSuppliers();
    }

    emptyList() {
        setTimeout(() => {
            this.autocompleteSearchlistSuppliers = [];
        }, 300);
    }

    getValue(_value: any) {
        // return this.translateService.getMultilingualFieldValue(value);
    }

    selectItem(item: any) {
        // select item in aucomplete list
        this.router.navigate(['suppliers/detail-supplier/' + item?.code]);
    }

    onExport() {
        let filters = [
            {
                fieldName: 'typeOfLegalEntity',
                conditions: [
                    {
                        type: 'EQUALS',
                        value: 'FOURNISSEUR',
                    },
                ],
            },
            {
                fieldName: 'status',
                conditions: [
                    {
                        type: 'EQUALS',
                        value: 'Publié',
                    },
                ],
            },
        ];

        if (this.searchSupplier) {
            filters.push({
                fieldName: 'companyName',
                conditions: [{ type: 'CONTAINS', value: this.searchSupplier }],
            });
        }

        const exportFileRequest: any = {
            filters: filters,
            fields: [
                'companyName',
                'address',
                'postcode',
                'city',
                'phone',
                'email',
                'linkToNaturalPersons',
            ],
            relationFields: {
                linkToNaturalPersons: [
                    'civility',
                    'lastName',
                    'firstName',
                    'job',
                    'phone',
                    'mobile',
                    'email',
                ],
            },
            locales: ['fr_FR'],
            sorts: { companyName: 'asc' },
        };

        let documentName = 'dynamic_legal_entity';
        let fileExtension = 'xlsx';
        this.dynamicDocumentService
            .exportFileWithContact(documentName, fileExtension, exportFileRequest)
            .subscribe((data: Blob) => {
                const blob = new Blob([data], { type: 'application/vnd.ms-excel' });
                const objectUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = objectUrl;
                link.download = `export.xlsx`;
                link.click();
                URL.revokeObjectURL(objectUrl);
            });
    }

    getSupplierVille(supplier: any): string {
        const ville = [];

        if (supplier?.postcode) {
            ville.push(supplier.postcode);
        }

        if (supplier?.city) {
            ville.push(supplier.city);
        }

        if (supplier?.country?.value) {
            if (supplier?.country?.labels) {
                ville.push(supplier?.country?.labels['fr_FR']);
            } else {
                ville.push(supplier?.country?.value);
            }
        }

        return ville.length ? ville.join(', ') : '-';
    }
}
